import React from 'react';
import { ExternalLink } from 'lucide-react';

interface LinkPreviewProps {
  url: string;
  title?: string;
  description?: string;
  image?: string;
  brandColor?: string;
}

export const LinkPreview: React.FC<LinkPreviewProps> = ({
  url,
  title,
  description,
  image,
  brandColor = "#060520"
}) => {
  // Extract domain for display
  const getDomainFromUrl = (url: string): string => {
    try {
      const domain = new URL(url).hostname;
      return domain.startsWith('www.') ? domain.substring(4) : domain;
    } catch (e) {
      return url;
    }
  };

  const domain = getDomainFromUrl(url);
  const displayTitle = title || domain;

  // Keep it simple for now, in production you might want to fetch metadata
  // for the URL to get title, description, and image
  
  return (
    <a 
      href={url} 
      target="_blank" 
      rel="noopener noreferrer"
      className="flex items-start gap-3 p-3 border rounded-md hover:bg-gray-50 transition-colors my-2 no-underline"
      style={{ borderColor: `${brandColor}30` }}
    >
      {image ? (
        <div className="w-16 h-16 rounded overflow-hidden flex-shrink-0 bg-gray-100">
          <img src={image} alt={displayTitle} className="w-full h-full object-cover" />
        </div>
      ) : (
        <div 
          className="w-12 h-12 rounded flex items-center justify-center flex-shrink-0 text-white"
          style={{ backgroundColor: brandColor }}
        >
          <ExternalLink size={16} />
        </div>
      )}
      
      <div className="flex-1 min-w-0">
        <h4 className="font-medium text-gray-900 mb-1 truncate">{displayTitle}</h4>
        {description && (
          <p className="text-sm text-gray-500 line-clamp-2">{description}</p>
        )}
        <p className="text-xs text-gray-400 mt-1 flex items-center">
          <span>{domain}</span>
          <ExternalLink size={12} className="ml-1" />
        </p>
      </div>
    </a>
  );
}; 